"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACKAGE_VERSION = exports.CONFIG_API_VERSION = exports.EudbCountries = exports.CloudPrefix = exports.CloudType = exports.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES = void 0;
exports.MAX_NUMBER_OF_TOKEN_FETCH_RETRIES = 3;
// Gov cloud types
var CloudType;
(function (CloudType) {
    CloudType["Public"] = "Public";
    CloudType["GccHigh"] = "GCC High";
    CloudType["Dod"] = "DoD";
})(CloudType || (exports.CloudType = CloudType = {}));
var CloudPrefix;
(function (CloudPrefix) {
    CloudPrefix["OrgId"] = "orgid";
    CloudPrefix["Acs"] = "acs";
    CloudPrefix["Spool"] = "spool";
    CloudPrefix["GccHigh"] = "gcch";
    CloudPrefix["GccHighAcs"] = "gcch-acs";
    CloudPrefix["Dod"] = "dod";
    CloudPrefix["DodAcs"] = "dod-acs";
})(CloudPrefix || (exports.CloudPrefix = CloudPrefix = {}));
exports.EudbCountries = ["europe", "france", "germany", "norway", "switzerland", "sweden"];
exports.CONFIG_API_VERSION = "2024-09-01";
exports.PACKAGE_VERSION = "1.0.0-beta.34";
